import {
  GLOBAL_COMMUNITY,
  OPEN_COMMUNITY,
  PUBLIC_COMMUNITY
} from '../../components/CommentInput/MentioningMenuUtilities';

/**
 * This function will generate a list of visible communities, a community is considered visible
 * if it is GLOBAL, PUBLIC or OPEN, or it is common to both the contentCommunities and userCommunities.
 * @param {object} contentCommunities an object of contentCommunities to check
 * @param {object} userCommunities an object of userCommunities to check
 * @returns an object containing the visible communities, if the contentCommunities or userCommunities arguments are falsey will return null.
 */
export const generateVisibleCommunites = (
  contentCommunities,
  userCommunities
) => {
  let returnValue = null;
  if (!userCommunities || !contentCommunities) {
    return returnValue;
  }
  const defaultComms = [GLOBAL_COMMUNITY, OPEN_COMMUNITY, PUBLIC_COMMUNITY];
  returnValue = {};
  Object.keys(contentCommunities).forEach((key) => {
    const contentCommunityType = contentCommunities[key]?.type;
    if (defaultComms.includes(contentCommunityType) || userCommunities[key]) {
      returnValue[key] = contentCommunities[key];
    }
  });
  return returnValue;
};

/**
 * This function will check whether a visible community exists for a content and user community combination.
 * A visisble community is when content is in a Public, Open or Global community, or the content is in a
 * protected or private community which the user is also a member of.
 * @param {object} contentCommunities the content communities
 * @param {*} userCommunities  the user communities
 * @returns true if a visible community exists, else false. A null value is returned if the contentCommunities parameter is invalid.
 */
export const hasVisibleCommunity = (contentCommunities, userCommunities) => {
  // if the content is in an open, public, global community then it is always "visible"
  // we don't need the userCommunities data for this check.
  let visibleCommunity = null;
  const visibleCommunityTypes = [
    GLOBAL_COMMUNITY,
    OPEN_COMMUNITY,
    PUBLIC_COMMUNITY
  ];
  const hasUserCommunities =
    userCommunities &&
    typeof userCommunities === 'object' &&
    Object.keys(userCommunities).length > 0;
  if (!contentCommunities || typeof contentCommunities !== 'object') {
    return visibleCommunity;
  }
  visibleCommunity = false;
  Object.keys(contentCommunities).every((key) => {
    const communityType = contentCommunities[key]?.type;
    if (communityType && visibleCommunityTypes.includes(communityType)) {
      visibleCommunity = true;
      return false;
    }
    if (hasUserCommunities) {
      const communityId = contentCommunities[key]?.id;
      if (communityId && communityId === userCommunities[key]?.id) {
        visibleCommunity = true;
        return false;
      }
    }
    return true;
  });
  return visibleCommunity;
};
